
















































import { Component, Vue, Emit } from 'vue-property-decorator';
import { INVITE_CODE_URL } from '../assets/js/urls';
const axios = require('../axios/index.js').default;

@Component
export default class DialogWithdraw extends Vue{
    inviteCode: string = "";
    dialogType: string = "normal";    // normal, success, fail
    failMsg: string = "You have been invited once";
    errMsg: string = "";

    focusInput() {
        this.errMsg = "";
    }

    checkCode() {
        let self = this;
        // console.log('check ...', self.inviteCode);

        if(self.inviteCode == '' || self.inviteCode.length < 6) {
            self.errMsg = "Invitation code not correct";
            self.inviteCode = "";
            return false;
        }else{
            self.errMsg = '';
            return true;
        }
    }

    // 提交
    submitFn() {
        let self = this;

        // console.log("self.inviteCode = ", self.inviteCode);
        
        self.$as.send('click_submit_invitecode_btn_DialogInviteCode');
        if(!self.checkCode()) {
            return;
        }

        let opts = {
            refCode: self.inviteCode
        }
        // console.log('send invite code: ', opts);
        axios.post(INVITE_CODE_URL, JSON.stringify(opts))
            .then((resp:any) => {
                // console.log('submit success', resp);
                let data = resp.data;
                if(data.status.code == 0) {
                    self.$as.send('submit_invitecode_successful_DialogInviteCode');
                    self.dialogType = 'success';
                }else{
                    self.$as.send('submit_invitecode_failed_DialogInviteCode');
                    self.dialogType = 'fail';
                    self.failMsg = data.status.reason;
                }
            })
            .catch((e:any) => {
                // console.log('err: ', e);
                self.$as.send('submit_invitecode_failed_DialogInviteCode');
                self.dialogType = 'fail';
            })
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeSuccessDialog() {
        this.$as.send('click_ok_btn_successful_DialogInviteCode');
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeFailedDialog() {
        this.$as.send('click_ok_btn_failed_DialogInviteCode');
    }

    // 关闭 Dialog
    @Emit('dialog-show')
    private closeDialog() {
        this.$as.send('click_close_btn_DialogInviteCode');
        return false;
    }
}
